import React from 'react'

const StyledSlide = ({ includeHeader = false, includeLogo = false }) => (
    <div style={{ height: '100%', backgroundSize: 'cover', position: 'relative' }} className="styled-slide pp-title-slide">
        {includeHeader ? (
            <div style={{ height: 10, backgroundColor: '#0B243A', position: 'relative' }}>
                <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 5, position: 'absolute', right: 2, top: 2 }} />
            </div>
        ) : null}

        {includeLogo ? (
            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 10, position: 'absolute', left: 2, top: 0, bottom: 0 }} />
        ) : null}
    </div>
)

export default StyledSlide
